module.exports = __webpack_public_path__ + "img/Grupo 1437@2x.b0dc35b1.png";